module.exports = __webpack_public_path__ + "img/spam3.1e37e1f1.png";